import React from "react";
import "./Home.css";
import Product from "./Product";
const Home = () => {
  const bannersrc =
    "https://m.media-amazon.com/images/I/61TD5JLGhIL._SX3740_.jpg";
  // "https://www.junglescout.com/wp-content/uploads/2020/05/Prime-day-banner.png";
  return (
    <div className="home">
      <div className="home__container">
        {/* Banner */}
        <img className="home__banner" alt="Banner" src={bannersrc} />
        <div className="home__row">
          <Product
            id={100}
            rating={3}
            price={879.0}
            title="HP Pavilion 24 All-in-One (2020)"
            image="https://i.pcmag.com/imagery/reviews/04xTDKsqdUzgKvWI7MGVnG3-1.fit_lim.size_238x139.v1598204639.jpg"
          />
          <Product
            id={100}
            rating={4}
            price={2109.99}
            title="HP Envy 34 All-in-One (2022)"
            image="https://i.pcmag.com/imagery/reviews/00xTIwo4AQMjnWl4H4ctDCq-1.fit_lim.size_238x139.v1643394203.jpg"
          />
          <Product
            id={100}
            rating={3}
            price={529 / 99}
            title=" HP Chromebase All-in-One 22 "
            image="https://i.pcmag.com/imagery/reviews/03vgWGzPszXGuw7ZDpulrMm-1.fit_lim.size_238x139.v1638566437.jpg"
          />
          <Product
            id={100}
            rating={2}
            price={179}
            title=" Velocity Micro Raptor Z55 (2021) "
            image="https://i.pcmag.com/imagery/reviews/005xF3NS0WSxnngqKTGJmy3-16.fit_lim.size_238x139.v1635969638.jpg"
          />
          {/* <Product /> */}
        </div>
        <div className="home__row">
          <Product
            id={100}
            rating={3}
            price={200}
            title="14-inch MacBook Pro with M1 Pro (2021)"
            image="https://cdn.vox-cdn.com/thumbor/EhHUKxrwKptgUgGjZTHwWq0VFoY=/0x0:1920x1080/400x400/filters:focal(960x540:961x541):format(webp)/cdn.vox-cdn.com/uploads/chorus_asset/file/22937105/Apple_16_inch_MacBook_Pro_2021_Press_Image.jpeg"
          />
          <Product
            id={100}
            rating={5}
            price={200}
            title="HP Spectre x360 14"
            image="https://cdn.vox-cdn.com/thumbor/xPcqFuojSIrRHHgOB1Ock6XvNbQ=/0x0:2005x1337/700x700/filters:focal(1003x669:1004x670):format(webp)/cdn.vox-cdn.com/uploads/chorus_asset/file/22279297/mchin_190429_4395_0004.jpg"
          />
          <Product
            id={100}
            rating={4}
            price={200}
            title="ASUS ROG ZEPHYRUS G15"
            image="https://cdn.vox-cdn.com/thumbor/fkqdeIuURQVsqN_PyAobro7xTJ0=/0x0:2040x1360/720x0/filters:focal(0x0:2040x1360):format(webp):no_upscale()/cdn.vox-cdn.com/uploads/chorus_asset/file/22341889/akrales_210226_4440_0022.jpg"
          />
          <Product
            id={100}
            rating={3}
            price={200}
            title="RAZER BLADE 17"
            image="https://cdn.vox-cdn.com/thumbor/PDrobtUVN57soqHdgTeJp48NGfE=/0x0:2040x1360/720x0/filters:focal(0x0:2040x1360):format(webp):no_upscale()/cdn.vox-cdn.com/uploads/chorus_asset/file/23262002/cfaulkner_141231_5037_0010.jpg"
          />
        </div>
        <div className="home__row">
          {/* <Product /> */}
          <Product
            id={100}
            rating={5}
            price={200}
            title="Sony WH-1000XM4"
            image="https://cdn.mos.cms.futurecdn.net/msQYTWV7cdatF5r9GbRvjM-650-80.jpg.webp"
          />
          <Product
            id={100}
            rating={4}
            price={200}
            title="Bose 700"
            image="https://cdn.mos.cms.futurecdn.net/HBCdKWgwPg6xyYTLCfxcCR-650-80.jpg.webp"
          />
          <Product
            id={100}
            rating={3}
            price={200}
            title="Apple AirPods Max"
            image="https://cdn.mos.cms.futurecdn.net/ThLofTvT933by5MA9Mz4BE-650-80.jpg.webp"
          />
          <Product
            id={100}
            rating={3}
            price={200}
            title="Jabra Elite Active 75t"
            image="https://cdn.mos.cms.futurecdn.net/D6Kuy7EMvAfHqciipYCunX-650-80.jpg.webp"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
